export const PARTNER_TASK_STATUS_NEEDS_REVIEW = 'needsReview';
export const PARTNER_TASK_STATUS_SENT = 'sent';
export const PARTNER_TASK_STATUS_IN_PROGRESS = 'inProgress';
export const PARTNER_TASK_STATUS_COMPLETED = 'completed';
export const PARTNER_TASK_STATUS_CANCELLED = 'cancelled';

export const PARTNER_TASK_STATUS_LIST = [
  PARTNER_TASK_STATUS_NEEDS_REVIEW,
  PARTNER_TASK_STATUS_SENT,
  PARTNER_TASK_STATUS_IN_PROGRESS,
  PARTNER_TASK_STATUS_COMPLETED,
  PARTNER_TASK_STATUS_CANCELLED,
];

export const PARTNER_TASK_CATEGORY_CLEAN = 'clean';
export const PARTNER_TASK_CATEGORY_LAWN = 'lawn';
export const PARTNER_TASK_CATEGORY_FIX = 'fix';
export const PARTNER_TASK_CATEGORY_PRICING = 'pricing';
